const getAuthToken = () => {
  return localStorage.getItem('access');
};

const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` }),
  };
};

// Function to handle 401 responses - logout and redirect
const handle401 = () => {
  // Clear all auth data from localStorage
  localStorage.removeItem('user');
  localStorage.removeItem('access');
  localStorage.removeItem('refresh');
  
  // Redirect to login page
  window.location.href = '/login';
};

// Helper function to handle API responses with 401 detection
const handleResponse = async (response: Response) => {
  if (response.status === 401) {
    handle401();
    throw new Error('Authentication expired. Please login again.');
  }
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    
    // Create an error object that preserves the backend error structure
    const error: any = new Error(errorData.detail || 'API request failed');
    error.response = errorData; // Preserve the full error response for field-specific errors
    error.status = response.status;
    throw error;
  }
  
  if (response.status === 204) return null;
  return response.json();
};

export const apiService = {
  get: async (url: string) => {
    const response = await fetch(url, {
      method: 'GET',
      headers: getAuthHeaders(),
    });
    return handleResponse(response);
  },
  
  post: async (url: string, data: any) => {
    const response = await fetch(url, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },
  
  put: async (url: string, data: any) => {
    const response = await fetch(url, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },
  
  delete: async (url: string) => {
    const response = await fetch(url, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return handleResponse(response);
  },
  
  patch: async (url: string, data: any) => {
    const response = await fetch(url, {
      method: 'PATCH',
      headers: getAuthHeaders(),
      body: JSON.stringify(data),
    });
    return handleResponse(response);
  },
}; 